export default {
  en: {
    formattingHelp: 'Formatting Help',
    refCodeFormattingHelp: 'Ref Code Formatting Help',
    yearOfStartValidContract: 'Year of start valid contract',
    yearOfEndValidContract: 'Year of end valid contract',
    hotelCode: 'Hotel Code',
    rateCode: 'Rate Code',
    allotmentType: 'Allotment Type',
    allotment: 'allotment',
    noAllotment: 'No allotment',
    agentMarketName: 'Agent market name',
    agentName: 'Agent name',
    promotionCode: 'Promotion Code'
  },
  th: {
    formattingHelp: 'ช่วยเหลือการจัดรูปแบบ',
    refCodeFormattingHelp: 'การจัดรูปแบบรหัสอ้างอิง',
    yearOfStartValidContract: 'ปีที่เริ่มต้นสัญญา',
    yearOfEndValidContract: 'ปีที่สิ้นสุดสัญญา',
    rateCode: 'ประเภทเรท',
    allotmentType: 'ประเภท allotment',
    allotment: 'allotment',
    noAllotment: 'ไม่มี allotment',
    agentMarketName: 'ชื่อตลาดของตัวแทน',
    agentName: 'ชื่อตัวแทน',
    promotionCode: 'รหัสโปรโมชั่น',
    hotelCode: 'รหัสโรงแรม'
  }
}
